import React from "react";
import { Table } from 'react-bootstrap';
import {
    ArrowUpRightCircle
} from 'tabler-icons-react';

const ExistingPatient = () => {
    return (
        <div className="existingRecords">

            {/* TABLE SECTION */}
            <h2 className="fade-in-tl5"><b>ALREADY REGISTERED PATIENTS</b></h2>
            <br />
            <div className="existingTable">
                <Table className="customTable fade-in-bottom9" striped bordered hover>
                    <thead>
                        <tr>
                            <th>SN</th>
                            <th className="existNameCol">NAME</th>
                            <th className="existLocCol">LOCATION</th>
                            <th><center>ACTIONS</center></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Tan A Meng</td>
                            <td>W22, R34, B45</td>
                            <td>
                                <button className="btnBlueSmall">
                                    <span>PROCEED TO REGISTER FOR THIS PATIENT THIS PATIENT</span>
                                    <ArrowUpRightCircle size={30} strokeWidth={2} color={'green'} />
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Tan A Tock</td>
                            <td>W22, R34, B45</td>
                            <td>
                                <button className="btnBlueSmall">
                                    <span>PROCEED TO REGISTER FOR THIS PATIENT THIS PATIENT</span>
                                    <ArrowUpRightCircle size={30} strokeWidth={2} color={'green'} />
                                </button>
                            </td>
                        </tr>
                        {/* <tr>
                            <td>3</td>
                            <td>Tan A Seng</td>
                            <td>W22, R34, B45</td>
                            <td>
                                <button className="btnBlueSmall">
                                    <span>PROCEED TO REGISTER FOR THIS PATIENT THIS PATIENT</span>
                                    <ArrowUpRightCircle size={30} strokeWidth={2} color={'green'} />
                                </button>  
                            </td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Tan A Lock</td>
                            <td>W22, R34, B45</td>
                            <td>
                                <button className="btnBlueSmall">
                                    <span>PROCEED TO REGISTER FOR THIS PATIENT THIS PATIENT</span>
                                    <ArrowUpRightCircle size={30} strokeWidth={2} color={'green'} />
                                </button>  
                            </td>
                        </tr> */}
                    </tbody>
                </Table>
            </div>

        </div>
    );
}

export default ExistingPatient;